export default __webpack_public_path__ + "static/media/iot.a008a802.png";